<template>
    <div v-if="hasPeopleToReview !== null" class="mt-3">
        <BaseButton ref="button" theme="tertiary" size="sm" class="whitespace-normal! text-left" @click="handleToggle">
            <template v-if="hasPeopleToReview">
                <i class="bi bi-dash-circle mr-1" aria-hidden="true"></i>
                {{ t("moments.reviewSwitcher.stopReviewingOthers", { momentTitle }) }}
            </template>
            <template v-else>
                <i class="bi bi-plus-circle mr-1" aria-hidden="true"></i>
                {{ t("moments.reviewSwitcher.startReviewingOthers", { momentTitle }) }}
            </template>
        </BaseButton>
        <BaseToast v-model:open="isErrorToastOpen" theme="error" :description="errorMessage" />
    </div>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import BaseToast from "~vue/components/BaseToast.vue";
import { ref, useTemplateRef } from "vue";
import { useI18n } from "vue-i18n";

import { useHasPeopleToReviewToggle } from "./composables/useHasPeopleToReviewToggle";

const props = withDefaults(
    defineProps<{
        hasPeopleToReview?: boolean | null;
        momentId?: string | number | null;
        momentTitle?: string | null;
    }>(),
    {
        hasPeopleToReview: null,
        momentId: null,
        momentTitle: "",
    },
);

const emit = defineEmits<{ toggled: [] }>();

const button = useTemplateRef<InstanceType<typeof BaseButton>>("button");
defineExpose({ focus: () => (button.value?.$el as HTMLElement | undefined)?.focus() });

const { t } = useI18n();
const { setHasPeopleToReview } = useHasPeopleToReviewToggle();

const isErrorToastOpen = ref(false);
const errorMessage = ref("");

const handleToggle = async () => {
    const saved = await setHasPeopleToReview(!props.hasPeopleToReview, props.momentId);
    if (!saved) {
        errorMessage.value = t("moments.reviewSwitcher.updateError");
        isErrorToastOpen.value = true;
        return;
    }
    emit("toggled");
};
</script>
